/* eslint-env jest */
import CarouselItem from './CarouselItem';
import collectImgs from '../../../testHelpers/collectImgs';

// Same direct-invocation pattern as AbsolutePosImgs.test.js: hooks and assets are
// mocked, the component is called as a function, and the element tree is inspected.

jest.mock('./MultiPose.module.scss', () => ({
  carouselItem: 'carouselItem',
  carouselImage: 'carouselImage',
  carouselBackground: 'carouselBackground',
  favoriteIcon: 'favoriteIcon',
  landscapeItem: 'landscapeItem',
  hidden: 'hidden',
}));
// No `virtual: true`: useImageOrientation is a real module, and a virtual mock
// of one only wins while no other suite resolves the real path first. See the
// note in AbsolutePosImgs.test.js.
jest.mock('../../../hooks/useImageOrientation', () => ({
  __esModule: true,
  default: () => ({ orientation: 'PORTRAIT' }),
  ORIENTATION: { LANDSCAPE: 'LANDSCAPE', PORTRAIT: 'PORTRAIT', UNKNOWN: 'UNKNOWN' },
}));

describe('CarouselItem', () => {
  const base = { favoriteIds: [], onClick: () => {} };

  it('gives plain items (backgrounds/poses) the width-filling carouselImage class', () => {
    // Without it, the legacy 218px-wide background files (Senior_Grey/Green/
    // Purple/White) render at natural size — smaller than their 640px
    // neighbors — whenever the tile is wider than 218px.
    const el = CarouselItem({
      ...base, item: { id: '5', imageUrl: 'https://s3/Senior_Grey.jpg', color: 'Senior Gray' },
    });
    const imgs = collectImgs(el);
    expect(imgs).toHaveLength(1);
    expect(imgs[0].className).toBe('carouselImage');
  });

  it('gives the clear-foreground tile (id 99999) the same width-filling class', () => {
    const el = CarouselItem({ ...base, item: { id: 99999 } });
    const imgs = collectImgs(el);
    expect(imgs).toHaveLength(1);
    expect(imgs[0].className).toBe('carouselImage');
    expect(imgs[0].alt).toBe('No foreground');
  });

  it('keeps the layered classes for pose-over-background items', () => {
    const el = CarouselItem({
      ...base,
      item: { id: '5', imageUrl: 'https://s3/fg.png' },
      background: { imageUrl: 'https://s3/bg.jpg' },
    });
    const classes = collectImgs(el).map((i) => i.className);
    expect(classes).toEqual(['carouselImage', 'carouselBackground']);
  });

  it("names the tile via the img alt so the button isn't anonymous to screen readers", () => {
    const bg = CarouselItem({ ...base, item: { id: '5', imageUrl: 'https://s3/x.jpg', color: 'Senior Blue' } });
    expect(collectImgs(bg)[0].alt).toBe('Senior Blue');

    const pose = CarouselItem({ ...base, item: { id: '6', imageUrl: 'https://s3/p.png', number: '03' } });
    expect(collectImgs(pose)[0].alt).toBe('Pose 03');
  });
});
